import {Component, Inject, OnInit} from '@angular/core';
import {MD_DIALOG_DATA, MdDialogRef} from '@angular/material';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AirportService} from '../../../airport/services/airport/airport.service';
import {AirlineService} from '../../../airline/services/airline/airline.service';
import {ContractService} from '../../../contract/services/contract/contract.service';
import {ContractFieldGroupService} from '../../../contract/services/contract-field-group/contract-field-group.service';
import {FlightScheduleService} from '../../../contract/services/flight-schedule-service/flight-schedule.service';
import {FlightScheduleColumnsService} from '../../../contract/services/flight-schedule-columns/flight-schedule-columns.service';

@Component({
  selector: 'app-clone-contract-dialog',
  templateUrl: './clone-contract-dialog.component.html',
  styleUrls: ['./clone-contract-dialog.component.scss']
})
export class CloneContractDialogComponent implements OnInit {

  coneContractForm: FormGroup;
  airlineOptions: Array<OptionsElement>;
  airportOptions: Array<OptionsElement>;
  constructor(public dialogRef: MdDialogRef<CloneContractDialogComponent>,
    @Inject(MD_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private airportService: AirportService,
    private airlineService: AirlineService,
    private contractService: ContractService,
    private contractFieldGroupService: ContractFieldGroupService,
    private flightScheduleService: FlightScheduleService,
    private flightScheduleColumnService: FlightScheduleColumnsService
              ) {
      this.airportOptions = new Array<OptionsElement>();
      this.airlineOptions = new Array<OptionsElement>();
      this.createForm();
      this.airportService.getAirports({limit: 999, page: 1})
        .then((response) => {
          for (const element of response.data) {
            this.airportOptions.push({name: element.name, id: element.id});
          }
        });
      this.airlineService.getAirlines({limit: 999, page: 1})
        .then((response) => {
          for (const element of response.data) {
            this.airlineOptions.push({name: element.name, id: element.id});
          }
        });
      this.contractService.getContract(this.data.contractId)
        .then((response) => {
          console.log(response);
        });
  }

  createForm() {
    this.coneContractForm = this.formBuilder.group({
      Airline: ['', Validators.required ],
      Airport: ['', Validators.required ]
    });
  }
  ngOnInit() {
  }
  onSubmit() {
    const formValue = this.coneContractForm.value;
    this.contractService.create({airport_id: formValue.Airport, airline_id: formValue.Airline})
      .then(
        (response) => {
          this.addContractFieldGroup(response.id, 1);
          this.addContractFieldGroup(response.id, 2);
          this.addContractFieldGroup(response.id, 3);
          this.addContractFieldGroup(response.id, 4);
          this.flightScheduleColumnService.getScheduleColumns(this.data.contractId)
            .then(
              (results) => {
              for (const element of results) {
                element.contract_id = response.id;
                this.flightScheduleColumnService.storeScheduleColumn(element);
              }
            }
          );
          this.flightScheduleService.getFlightSchedules(this.data.contractId)
            .then((results) => {
              for (const element of results) {
                element.contract_id = response.id;
                this.flightScheduleService.upsert(element);
              }
            }
          )
        }
      );
    this.dialogRef.close(formValue);
  }

  addContractFieldGroup(id: number, type: number) {
    this.contractFieldGroupService.getContractFieldGroups(this.data.contractId, type, false)
      .then(
        (result) => {
          for (const element of result) {
            element.contract_id = id;
            this.contractFieldGroupService.createContractFieldGroup(element);
          }
        }
      );
  }
}

interface OptionsElement {
  id: number,
  name: string,
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/components/clone-contract-dialog/clone-contract-dialog.component.ts